// extracted by css-extract-rspack-plugin
export default {"gap_2":"IconAndColorPicker-module__gap_2__HB8tx"};